import clsx from 'clsx';
import { type HTMLAttributes, type ReactNode, forwardRef } from 'react';

export type BadgeTone = 'neutral' | 'coral' | 'leaf' | 'sun' | 'sky' | 'dusk' | 'ember';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  /** Show a leading dot — great for live/status indicators. */
  dot?: boolean;
  children: ReactNode;
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(function Badge(
  { tone = 'neutral', dot = false, className, children, ...rest },
  ref,
) {
  return (
    <span ref={ref} className={clsx('perch-badge', className)} data-tone={tone} {...rest}>
      {dot ? <span className="perch-badge-dot" aria-hidden="true" /> : null}
      {children}
    </span>
  );
});
